import React, { Suspense } from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { Box, Skeleton, Typography } from '@mui/material';

import CheckMarkList from '../CheckMarkList';

const Map = React.lazy(() => import('./map.svg?react'));

const getRegions = () => [
  {
    title: i18n.t('supported-regions.regions.europe.title'),
    description: i18n.t('supported-regions.regions.europe.description'),
  },
  {
    title: i18n.t('supported-regions.regions.north-america.title'),
    description: i18n.t('supported-regions.regions.north-america.description'),
  },
  {
    title: i18n.t('supported-regions.regions.south-america.title'),
    description: i18n.t('supported-regions.regions.south-america.description'),
  },
  {
    title: i18n.t('supported-regions.regions.oceania.title'),
    description: i18n.t('supported-regions.regions.oceania.description'),
  },
  {
    title: i18n.t('supported-regions.regions.central-asia.title'),
    description: i18n.t('supported-regions.regions.central-asia.description'),
  },
  {
    title: i18n.t('supported-regions.regions.middle-east.title'),
    description: i18n.t('supported-regions.regions.middle-east.description'),
  },
  {
    title: i18n.t('supported-regions.regions.africa.title'),
    description: i18n.t('supported-regions.regions.africa.description'),
  },
];

export default function SupportedRegions() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'grid',
        rowGap: 2,
        columnGap: '30px',
        mt: 5,
        p: { xs: 0, md: '16px 24px' },
      }}
    >
      <Typography
        variant="h2"
        sx={{
          display: { xs: 'none', sm: 'block' },
          gridColumn: { sm: '1 / 3', md: '1 / 2' },
          gridRow: { sm: '1 / 2', md: '1 / 2' },
        }}
      >
        {t('supported-regions.title')}
      </Typography>
      <Typography
        variant="h2"
        sx={{
          display: { xs: 'block', sm: 'none' },
          gridColumn: '1 / 3',
          gridRow: '1 / 2',
        }}
      >
        {t('supported-regions.supported-countries')}
      </Typography>
      <CheckMarkList
        styles={{
          list: {
            gridColumn: { xs: '1 / 3', md: '1 / 2' },
            gridRow: { xs: '3 / 4', md: '2 / 3' },
          },
          listSubheader: {
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            mb: 0,
          },
        }}
        title={t('supported-regions.description')}
        items={getRegions()}
      />
      <Box
        sx={{
          position: 'relative',
          gridColumn: { xs: '1 / 3', md: '2 / 3' },
          gridRow: { xs: '2 / 3', md: '1 / 3' },
          height: { xs: '220px', sm: 'auto' },
        }}
      >
        <Box
          sx={(theme) => ({
            position: { xs: 'absolute', sm: 'static' },
            top: { xs: 0 },
            bottom: { xs: 0 },
            left: { xs: theme.spacing(-1) },
            right: { xs: theme.spacing(-1) },
          })}
        >
          <Suspense
            fallback={
              <Skeleton
                variant="rounded"
                sx={{
                  width: { md: 500, sm: 800 },
                  height: { xs: 220, sm: 380 },
                }}
              />
            }
          >
            <Map style={{ maxHeight: '100%', width: '100%' }} />
          </Suspense>
        </Box>
      </Box>
    </Box>
  );
}
